import React from "react";
import { Box, Heading, Tooltip, Icon } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { useSelector } from "react-redux";

import FilterForm from "../../../components/FilterForm";
import BranchAverageWaitTimePerService from "../../../components/branches/reports/realtime/BranchAverageWaitTimePerService";
import { Helmet } from "react-helmet";

const BranchAverageWaitTimePerServicePage = ({
  showFilterForm = true,
  showTitle = 1,
}) => {
  const { reportRange } = useSelector((state) => state.defaultReducer);

  return (
    <Box>
      {showTitle === 1 && (
        <Helmet>
          <title>Realtime Branch Average Wait Time Per Service</title>
        </Helmet>
      )}
      {showFilterForm ? <FilterForm /> : null}
      <Box mb="20px">
        <Heading fontSize="34px" color="#222" fontWeight="700">
          Average Wait Time Per Service
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                Realtime overview of the average wait time per service per
                branch. Including a line-chart with an hour by hour comparison
                of average wait time per service.
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
      </Box>
      <BranchAverageWaitTimePerService />
    </Box>
  );
};

export default BranchAverageWaitTimePerServicePage;
